/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './warranty-loading-indicator.scss';
import PropTypes from 'prop-types';
import React from 'react';

const WarrantyLoadingIndicator = (props) => (
    <div
        className="loading-indicator"
    >
        {props.isLoading && (
            <div className="spinner">
                <div className="dotspace bounce1" />
                <div className="dotspace bounce2" />
                <div className="dotspace bounce3" />
                <div className="dotspace bounce4" />
            </div>
        )}
    </div>
);
WarrantyLoadingIndicator.displayName = 'WarrantyLoadingIndicator';
WarrantyLoadingIndicator.propTypes = {
    isLoading: PropTypes.bool.isRequired,
};

export default WarrantyLoadingIndicator;
